/**
 * TanStack Query hooks for `invoice-attachment-bank-details-compliance-docs`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invoiceAttachmentBankDetailsComplianceDocsQueryKeys,
	type CreateInvoiceAttachmentBankDetailsComplianceDocsBody,
	type ListInvoiceAttachmentBankDetailsComplianceDocsResponse,
	type InvoiceAttachmentBankDetailsComplianceDocsRow,
} from "./api";

export function useInvoiceAttachmentBankDetailsComplianceDocsList(): UseQueryResult<ListInvoiceAttachmentBankDetailsComplianceDocsResponse, Error> {
	return useQuery({
		queryKey: invoiceAttachmentBankDetailsComplianceDocsQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvoiceAttachmentBankDetailsComplianceDocsCreate(): UseMutationResult<InvoiceAttachmentBankDetailsComplianceDocsRow, Error, CreateInvoiceAttachmentBankDetailsComplianceDocsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceAttachmentBankDetailsComplianceDocsQueryKeys.all });
		},
	});
}

export function useInvoiceAttachmentBankDetailsComplianceDocsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceAttachmentBankDetailsComplianceDocsQueryKeys.all });
		},
	});
}
